module.exports = __webpack_public_path__ + "static/assets/94e94c7fb012e2c6669d19d2f33f3885.png";